import React, { useState } from 'react'
import './Login.css'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export const loginSchema = () => {
    let [passwordShown, setPasswordShown] = useState(false)

    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true)
    }

    return {
        initialValues: {
            phone: localStorage.phone ? localStorage.phone : '',
            password: localStorage.password ? localStorage.password : '',
            remember_me: localStorage.remember_me ? localStorage.remember_me : false,
        },
        validationArray: Yup.object({
            phone: Yup.string()
                .trim()
                .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
                .max(17, 'Maximum 10 Number')
                .min(11, 'Invalid Phone Number')
                .required('Required!'),
            password: Yup.string().required('Required'),
        }),
        login: {
            formData: [
                // {
                //     label: 'Email address',
                //     name: 'email',
                //     type: 'email',
                //     placeholder: 'Enter your email address',
                //     class: 'col-12',
                //     autoFocus: true,
                // },
                {
                    label: 'Phone Number',
                    name: 'phone',
                    upperLabel: true,
                    type: 'phone',
                    placeholder: 'Enter your phone number',
                    class: 'col-12 loginInputFields',
                    displayFlag: true,
                    autoFocus: true,
                },
                {
                    label: 'Password',
                    name: 'password',
                    upperLabel: true,
                    type: passwordShown ? 'text' : 'password',
                    placeholder: 'Enter your password',
                    class: 'col-12 loginInputFields',
                    endAdornment: passwordShown ? (
                        <span
                            className="material-icons cursorPointer"
                            onClick={togglePasswordVisiblity}
                        >
                            visibility_off
                        </span>
                    ) : (
                        <span
                            className="material-icons cursorPointer"
                            onClick={togglePasswordVisiblity}
                        >
                            visibility
                        </span>
                    ),
                },
            ],
        },
        rememberMe: false,
    }
}
